var exports = {
  "Qs": "GuildOwnershipWarningModal.module__content___Tk5vS1",
  "OW": "GuildOwnershipWarningModal.module__guildList___Tk5vS1",
  "RZ": "GuildOwnershipWarningModal.module__guildItem___Tk5vS1",
  "$f": "GuildOwnershipWarningModal.module__guildIcon___Tk5vS1",
  "OA": "GuildOwnershipWarningModal.module__guildInfo___Tk5vS1",
  "J5": "GuildOwnershipWarningModal.module__guildName___Tk5vS1",
  "i1": "GuildOwnershipWarningModal.module__remainingCount___Tk5vS1",
  "BK": "GuildOwnershipWarningModal.module__helpText___Tk5vS1",
};

module.exports = exports;
